import {
  getSession,
  loadPilot,
  loadRackerPilot,
  isRacker,
} from '@rss-engineering/fabric-ui-session';
import { SESSION_EMAIL_KEY } from 'appConstants';
import { FeatureFlags, MiscUtils } from 'services';

const expiredSession = { handle_expired_session: true };
const queryNavSelector = document.querySelector('#nav-pilot');
const usertype = isRacker() ? 'racker' : 'customer';

if (isRacker()) {
  loadRackerPilot(queryNavSelector, {}, expiredSession);
} else {
  loadPilot(queryNavSelector, {}, expiredSession);
}

Promise.resolve(getSession()).then((session) => {
  let federatedIdp = '';

  if (
    session.session.identity.access &&
    session.session.identity.access.user &&
    session.session.identity.access.user['RAX-AUTH:federatedIdp']
  ) {
    federatedIdp =
      session.session.identity.access.user['RAX-AUTH:federatedIdp'];
  }

  if (isRacker()) {
    let tenantValue;
    const currentUrl = window.location.href.split('/');
    const urlDomainId = currentUrl[currentUrl.indexOf('racker') + 1];
    let id = '';
    if (urlDomainId.includes(':')) {
      // dedicated user
      id = urlDomainId.split(':')[1];
    } else {
      // cloud user
      id = urlDomainId;
    }

    if (urlDomainId.includes('dedicated')) {
      tenantValue = `hybrid:${id}`;
    } else {
      tenantValue = id;
    }

    window.PORTAL_DATA = {
      domainId: urlDomainId,
      userId: session.session.identity.access.user.id,
      username: session.session.identity.access.user.name,
      tenants: [tenantValue],
      federatedIdp: federatedIdp,
      email: session.session.saml[SESSION_EMAIL_KEY],
      contactId: session.session.saml.contact_id || '',
    };
  } else {
    let tenantValue;
    if (session.session.saml.domain.includes('dedicated')) {
      tenantValue = 'hybrid:' + session.session.saml.account_id;
    } else {
      tenantValue = session.session.saml.account_id;
    }
    let contactId = session.session.saml.contact_id || '';
    window.PORTAL_DATA = {
      domainId: session.session.saml.domain,
      userId: session.session.saml.user_id,
      username: session.session.saml.username,
      tenants: [tenantValue],
      email: session.session.saml[SESSION_EMAIL_KEY],
      federatedIdp: federatedIdp,
      contactId: contactId,
    };
  }

  Promise.resolve(import('./app')).then((app) => {
    (document.getElementById('app-loader') as HTMLElement).style.display =
      'none';
    if (FeatureFlags.isActive('ctui-responsive')) {
      // Add css related to FDS
      require('fds-styles.css');
    }
    app.start(document.querySelector('#app'), window.PORTAL_DATA);
  });

    /**
     * Datadog user setting
     */
    if (!MiscUtils.isLocalDev) {
      window.DD_RUM.onReady(() => {
        window.DD_RUM.setUser({
          id: session.session?.identity?.access?.user?.id,
          user_id: session.session?.identity?.access?.user?.id,
          user_name: session.session?.identity?.access?.user?.name,
          user_email: session.session?.saml?.email,
          user_type: usertype,
          user_domain: session.session?.identity?.access?.user?.['RAX-AUTH:domainId'],
        });
      });
    }
});
